import type { ComponentProps } from "react"
import { RadioGroup as RadioGroupBase } from "@/v2-ui/radioGroup/base/RadioGroupBase"
import cn from "@/v2-ui/utils/utils.cn"

export type RadioGroupProps = ComponentProps<typeof RadioGroupBase>

function RadioGroup(props: RadioGroupProps) {
  const { className, ...radioGroupBaseProps } = props
  return (
    <RadioGroupBase
      className={cn("ui-radio-group", className)}
      {...radioGroupBaseProps}
    />
  )
}

export default RadioGroup
